import { createSlice } from '@reduxjs/toolkit';
import {
  getReferenceCodeConfig,
  putReferenceCodeConfig,
  getGlobalReferenceCodeConfig,
  putGlobalReferenceCodeConfig,
  getExclusiveReferenceCodeConfig,
  putExclusiveReferenceCodeConfig,
} from './services';
import initialState from './initialState';

const ReferenceCodesSlice = createSlice({
  name: 'ReferenceCodesSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReferenceCodeConfig.pending, (state) => {
        state.config.loading = true;
        state.config.error = false;
      })
      .addCase(getReferenceCodeConfig.fulfilled, (state, action) => {
        state.exclusive = action.payload.exclusive;
        state.global = action.payload.global;
        state.config.allow_manual_edit = action.payload.allow_manual_edit;
        state.config.loading = false;
        state.config.error = false;
      })
      .addCase(getReferenceCodeConfig.rejected, (state) => {
        state.config.loading = false;
        state.config.error = true;
      })
      .addCase(putReferenceCodeConfig.pending, (state, action) => {
        state.previousExclusive = { ...state.exclusive };
        state.previousAllowManualEdit = state.config.allow_manual_edit;

        const { allow_manual_edit, exclusive_enabled } = action.meta.arg;
        if (allow_manual_edit !== undefined) {
          state.config.allow_manual_edit = allow_manual_edit;
        }
        if (exclusive_enabled !== undefined) {
          state.exclusive.enabled = exclusive_enabled;
        }
        state.config.loading = true;
        state.config.error = false;
      })
      .addCase(putReferenceCodeConfig.fulfilled, (state, action) => {
        state.exclusive = action.payload.exclusive;
        state.global = action.payload.global;
        state.config.allow_manual_edit = action.payload.allow_manual_edit;
        state.config.loading = false;
        state.config.error = false;
      })
      .addCase(putReferenceCodeConfig.rejected, (state) => {
        state.exclusive = state.previousExclusive;
        state.config.allow_manual_edit = state.previousAllowManualEdit;
        state.config.loading = false;
        state.config.error = true;
      })
      .addCase(getGlobalReferenceCodeConfig.pending, (state) => {
        state.globalConfig.loading = true;
        state.globalConfig.error = false;
      })
      .addCase(getGlobalReferenceCodeConfig.fulfilled, (state, action) => {
        state.globalConfig.development_types = action.payload.development_types;
        state.globalConfig.property_types = action.payload.property_types;
        state.globalConfig.company_prefix = action.payload.company_prefix;
        state.globalConfig.mode = action.payload.mode;
        state.globalConfig.loading = false;
        state.globalConfig.error = false;
      })
      .addCase(getGlobalReferenceCodeConfig.rejected, (state) => {
        state.globalConfig.loading = false;
        state.globalConfig.error = true;
      })
      .addCase(putGlobalReferenceCodeConfig.pending, (state) => {
        state.globalConfig.loading = true;
        state.globalConfig.error = false;
      })
      .addCase(putGlobalReferenceCodeConfig.fulfilled, (state, action) => {
        state.globalConfig.company_prefix = action.payload.company_prefix;
        state.globalConfig.property_types =
          action.payload.property_types ?? state.globalConfig.property_types;
        state.globalConfig.development_types =
          action.payload.development_types ??
          state.globalConfig.development_types;
        state.globalConfig.mode = action.payload.mode;
        state.globalConfig.loading = false;
        state.globalConfig.error = false;
      })
      .addCase(putGlobalReferenceCodeConfig.rejected, (state) => {
        state.globalConfig.loading = false;
      })
      .addCase(getExclusiveReferenceCodeConfig.pending, (state) => {
        state.exclusiveConfig.loading = true;
        state.exclusiveConfig.error = false;
      })
      .addCase(getExclusiveReferenceCodeConfig.fulfilled, (state, action) => {
        state.exclusiveConfig.branches = action.payload.branches;
        state.exclusiveConfig.users = action.payload.users;
        state.exclusiveConfig.mode = action.payload.mode;
        state.exclusiveConfig.team_supported = action.payload.team_supported;
        state.exclusiveConfig.loading = false;
        state.exclusiveConfig.error = false;
        state.exclusiveConfig.hasLoaded = true;
      })
      .addCase(getExclusiveReferenceCodeConfig.rejected, (state) => {
        state.exclusiveConfig.loading = false;
        state.exclusiveConfig.error = true;
        state.exclusiveConfig.hasLoaded = true;
      })
      .addCase(putExclusiveReferenceCodeConfig.pending, (state, action) => {
        if (!action.meta.arg?.silent) {
          state.exclusiveConfig.loading = true;
        }
        state.exclusiveConfig.error = false;
      })
      .addCase(putExclusiveReferenceCodeConfig.fulfilled, (state, action) => {
        state.exclusiveConfig.branches = action.payload.branches;
        state.exclusiveConfig.users = action.payload.users;
        state.exclusiveConfig.mode = action.payload.mode;
        state.exclusiveConfig.team_supported = action.payload.team_supported;
        state.exclusiveConfig.loading = false;
        state.exclusiveConfig.error = false;
      })
      .addCase(putExclusiveReferenceCodeConfig.rejected, (state) => {
        state.exclusiveConfig.loading = false;
      });
  },
});

export {
  getReferenceCodeConfig,
  putReferenceCodeConfig,
  getGlobalReferenceCodeConfig,
  putGlobalReferenceCodeConfig,
  getExclusiveReferenceCodeConfig,
  putExclusiveReferenceCodeConfig,
};

export default ReferenceCodesSlice.reducer;
